import { Injectable } from '@angular/core';
import { DataService } from './data.service';

/**
 *  AZ AKTÍV CÉG A MODULOK KÖZÖTT (Könyvelés – Bérszámfejtés – Tárgyi eszköz).
 *
 *  Mindhárom modul maga emlékszik a saját aktív ügyfelére, ezért modulváltás után a LEGUTÓBB ott
 *  választott cég jött fel – nem az, amelyiken épp dolgoztunk. Itt jegyezzük fel, melyik modulban
 *  melyik (könyvelési) ügyfél volt utoljára aktív; a modulba belépve, ha az előző modul másik
 *  cégen állt, és ahhoz van ebben a modulban párja, azt választjuk ki.
 *
 *  A közös kulcs a KÖNYVELÉSI ügyfél azonosítója (naplo_ugyfel.id): a Tárgyi eszköz ugyanezt a
 *  törzset használja, a bér-ügyfél pedig a `ber_ugyfel.naplo_ugyfel_id` kötéssel mutat rá. Ha a
 *  bér-ügyfél nincs összekötve, null-t jegyzünk – ilyenkor a többi modul a saját legutóbbiján marad.
 */
export type KozosModul = 'NAPLO' | 'BER' | 'ESZKOZ' | 'SZAMLAZO' | 'INVENTARIO' | 'GEPJARMU';

@Injectable({ providedIn: 'root' })
export class KozosCegService {
  private static readonly KULCS = 'kozosAktivCeg';
  constructor(private data: DataService) {}

  /** Feljegyzi, hogy a modulban ez a (könyvelési) ügyfél lett aktív. */
  async jelol(modul: KozosModul, naploUgyfelId: string | null): Promise<void> {
    try { await this.data.setStorage(KozosCegService.KULCS, { modul, naploUgyfelId: naploUgyfelId || null, ido: Date.now() }); }
    catch { /* nem kritikus */ }
  }

  /** A MÁSIK modulban utoljára aktív cég könyvelési azonosítója – null, ha nincs mit átvenni. */
  async atveendo(modul: KozosModul): Promise<string | null> {
    try {
      const k = await this.data.getFromStorage(KozosCegService.KULCS);
      return k && k.modul !== modul && k.naploUgyfelId ? String(k.naploUgyfelId) : null;
    } catch { return null; }
  }
}
